import React from 'react';
export function Footer() {
  return <footer className="bg-[#061539] text-white/60 py-12 px-5 text-center text-[13px]" data-id="element-90">
      <div className="max-w-xl mx-auto" data-id="element-91">
        <div className="text-white font-bold text-lg mb-4 flex items-center justify-center gap-2" data-id="element-92">
          <span data-id="element-93">🤝</span> Sistema LSA Fácil™
        </div>

        <p className="mb-8 leading-relaxed max-w-sm mx-auto" data-id="element-94">
          El sistema N°1 para aprender Lengua de Señas Argentina de forma
          progresiva, práctica y adaptada a la vida real en Argentina.
        </p>

        <div className="flex flex-col gap-2 mb-8" data-id="element-95">
          <a href="mailto:soportetusbeneficios@gmail.com" className="hover:text-white transition-colors" data-id="element-96">
            📧 soportetusbeneficios@gmail.com
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-97">
            📱 @centralpack.ar
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-98">
            🌐 centralpack.shop
          </a>
        </div>

        <div className="border-t border-white/10 pt-8 mb-8" data-id="element-99">
          © Sistema LSA Fácil™ 2026 — Todos los derechos reservados.
        </div>

        <p className="italic text-white/40 font-medium" data-id="element-100">
          🤟 "Más que aprender señas, es conectar personas."
        </p>
      </div>
    </footer>;
}